// extracted by mini-css-extract-plugin
export default {"weight":"coffeeDetails_weight__yqtdF","weightActive":"coffeeDetails_weightActive__PNRMP","addToCart":"coffeeDetails_addToCart__cfqz8"};